import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@core/services/lingo2-account/auth.service';
import { PlatformService } from '@core/services/platform.service';
import { DestroyableComponent } from '@models/destroyable.component';
import { EContentPanelRoute, IContentPane } from 'lingo2-models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export const bffRoutes = [
  EContentPanelRoute.classes,
  EContentPanelRoute.tutors,
  EContentPanelRoute.lessons,
  EContentPanelRoute.collections,
  EContentPanelRoute.schools,
  EContentPanelRoute.main,
  '/u/',
];

interface BffPayload {
  [key: string]: any;
}

@Injectable({
  providedIn: 'root',
})
export class BffService extends DestroyableComponent {
  private readonly bffUrl = `${environment.bff_url}/chapter`;

  constructor(
    protected authService: AuthService,
    protected http: HttpClient,
    protected readonly platform: PlatformService,
  ) {
    super(platform);
  }

  public bff(payload: BffPayload, type: EContentPanelRoute): Observable<IContentPane[]> {
    const endpoint = type.toLowerCase();
    return this.makeBffRequest(endpoint, payload);
  }

  private makeBffRequest(endpoint: string, payload: BffPayload): Observable<IContentPane[]> {
    const url = `${this.bffUrl}/${endpoint}`;
    return this.http.post<IContentPane[]>(url, payload, { observe: 'response' }).pipe(map((response) => response.body));
  }

  public bffUserProfile(id?: string, slug?: string): Observable<IContentPane[]> {
    const url = `${this.bffUrl}/user-profile/info`;
    const params = new HttpParams();

    if (id) {
      params.set('id', id);
    }
    if (slug) {
      params.set('slug', slug);
    }

    return this.http.get<IContentPane[]>(url, { params, observe: 'response' }).pipe(map((response) => response.body));
  }
}
